export default __webpack_public_path__ + "static/media/colombia_flag.e6fa28db.svg";